import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RoutingPath } from '@app/core/Enum/routing-path';

@Component({
  selector: 'app-authorization-popup',
  templateUrl: './authorization-popup.component.html',
  styleUrls: ['./authorization-popup.component.scss']
})
export class AuthorizationPopupComponent implements OnInit {

  constructor(private router: Router,
    public dialogRef: MatDialogRef<AuthorizationPopupComponent>) { }

  ngOnInit(): void {
    //do nothing
  }

  redirect():void{
    this.dialogRef.close(true);
    this.router.navigate([RoutingPath.ViewVatDetails]);
  }

  onCloseClick(): void{
    this.dialogRef.close(true);
  }
}
